import React, { Component } from 'react'
import { withRouter } from 'react-router'
import URLUtils from '../../util/URLUtils'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils'
import InviteAcceptPageUI from './InviteAcceptPageUI.js'

class InviteAcceptPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      newUser: true,
      userId: null,
      accountId: null,
      email: null,
      firstName: null,
      lastName: null,
      accountName: null,
      messageList: null,
      socialLoginUrl: null,
      errorList: null,
      showFBLogin: false
    }
  }

  render() {
    return (
      <InviteAcceptPageUI
        context={this.props.context}
        newUser={this.state.newUser}
        userId={this.state.userId}
        accountId={this.state.accountId}
        email={this.state.email}
        firstName={this.state.firstName}
        lastName={this.state.lastName}
        accountName={this.state.accountName}
        messageList={this.state.messageList}
        socialLoginUrl={this.state.socialLoginUrl}
        errorList={this.state.errorList}
        showFBLogin={this.state.showFBLogin}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.acceptInvite(context)
    this.getSocialLoginUrl(context)

    let params = new URLSearchParams(window.location.search)
    let showFBLogin = params.has('fb')
    this.setState({showFBLogin: showFBLogin})
  }

  acceptInvite(context) {
    let encryptedUserId = this.props.match.params.encryptedUserId
    let accountId = this.props.match.params.accountId
    RestApiUtils.post(this.props.context,
      `/api/pub/accounts/${accountId}/users/${encryptedUserId}/invite-accept`,
      this.acceptInviteCallback, {}
    )
  }

  acceptInviteCallback = (response) => {
    if (response.errorList.length) {
      this.setState({
        errorList: response.errorList
      })
    }
    else {
      this.setState({
        newUser: response.newUser,
        userId: response.userId,
        accountId: response.accountId,
        email: response.email,
        firstName: response.firstName,
        lastName: response.lastName,
        accountName: response.accountName
      })
    }

    let context = this.props.context
    this.getMessages(context)
  }

  getSocialLoginUrl(context) {
    let cacheManager = new CacheManager({
      resource: '/api/pub/socialLoginUrl',
      cacheKey: CacheKeys.SocialLoginUrl,
      callback: this.getSocialLoginUrlCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context, {}, {baseUrl: URLUtils.getBaseURL()})
  }

  getSocialLoginUrlCallback = (response) => {
    this.setState({socialLoginUrl: response})
  }

  getMessages(context) {
    let arr = [
      'c_invitation_accepted',
      'c_acct_inv_acpt_signin',
      'c_acct_inv_acpt_goacc',
      'c_continue',
      'c_sign_up',
      'c_or',
      'c_login_with_fb',
      'c_login_with_g'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_inv_acc', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
    // cannot check session here because user id was encrypted in URL
    // this.checkSession()
  }

  /*
  // if user id not matching, logout the user
  checkSession() {
    let context = this.props.context
    let userIdsession = context.session.userId
    let userIdParam = this.props.match.params.userId
    if (userIdsession && userIdsession !== userIdParam) {
      sessions.delete(context, this.deleteSessionCallback)
    }
  }

  deleteSessionCallback = (response) => {
    let context = this.props.context
    localStorage.removeItem(LocalStorageKeys.Session)
    localStorage.removeItem(LocalStorageKeys.Session + ':CachedTime')
    let sessionHelper = new SessionHelper(context)
    sessionHelper.getSession()
  }
  */

}

export default withRouter(InviteAcceptPageSF)
